// 1. The generic duplicate checker
type HasDuplicates<T extends readonly any[]> = T extends readonly [infer Head, ...infer Rest]
  ? Head extends Rest[number]
    ? true
    : HasDuplicates<Rest>
  : false;

// 2. The Validation logic
// Enum = The Enum type. T = The array of provided arguments.
type ValidateOrder<Enum, T extends readonly Enum[]> = [Enum] extends [T[number]]
  ? HasDuplicates<T> extends true
    ? ['Error: Arguments have duplicates']
    : T
  : ['Error: Missing enum values'];

// 3. The Curried Factory Function
export const enumOrderValidator = <Enum extends string | number>() => {
  return <const T extends readonly Enum[]>(
    // If T passes validation, expect T. If it fails, expect the Error tuple.
    ...args: T extends ValidateOrder<Enum, T> ? T : ValidateOrder<Enum, T>
  ) => args;
};
